module.exports = __webpack_public_path__ + "img/stack.fb1a18fe.svg";